import React from "react";
import "./team.css";

import shooting from "../../Assets/Images/TeamWorkout/tm1.png";
import offensive from "../../Assets/Images/TeamWorkout/tm2.png";
import ballhandling from "../../Assets/Images/TeamWorkout/tm3.png";
import toughness from "../../Assets/Images/TeamWorkout/tm4.png";
import rebounding from "../../Assets/Images/TeamWorkout/tm5.png";
import teameval from "../../Assets/Images/TeamWorkout/tm6.png";
import defensive from "../../Assets/Images/TeamWorkout/tm7.png";

export default function Team() {
  const items = [
    { title: "Shooting", image: shooting },
    { title: "Offensive Chemistry", image: offensive },
    { title: "Ball Handling", image: ballhandling },
    { title: "Toughness", image: toughness },
    { title: "Rebounding", image: rebounding },
    { title: "Team Evaluation", image: teameval },
    { title: "Defensive Schemes", image: defensive },
  ];

  return (
    <div className="team-section bg-custom brightness">
      <div className="container">
        <div className="w-full py-16 text-center bg-custom">
          <h2 className="text-4xl font-bold mb-6 brightness">TEAM</h2>
          <p className="team-description text-clip">
            At Team Workouts, we put a full team through a workout that is
            focused on any aspect of basketball that the coach of the team would
            like. We have had coaches call us to focus in on all of the
            following:
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 px-6">
            {items.map((item, i) => (
              <div key={i} className="rounded-xl overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-56 object-cover"
                />
                <div className="team-title">
                  <h3 className="text-xl font-semibold">{item.title}</h3>
                </div>
              </div>
            ))}
          </div>

          <p className="team-description text-clip">
            *Sometimes a coach is unaware of exactly what his/her team needs the
            most. In these cases, we can provide a Team Evaluation and give our
            opinion on what would be the most effective strategy for the team.
          </p>

          <h4
            className="text-clip"
            style={{
              textAlign: "center",
              fontSize: "22px",
              "--clip-color": "#1A1A1A",
              fontWeight: 700,
            }}
          >
            Our coaching staff has helped many different teams take their game
            to the next level.
          </h4>
        </div>
      </div>
    </div>
  );
}
